import { useEffect, useState } from "react";

import { FormGroup, FormInput, FormInputGroup, FormTitle, InputLabel, ModalBtn, PlusIcon, PriceFormContainer, PricingForm, SubTitle, TableAction, TableActions, Title } from "Pricing/Styles";
import SelectField from "Business/AddBusiness/SelectField";
import SharedCheckList from "shared/clientcomponents/SharedCheckList";
import toast from "shared/utils/toast";
import { getCurrentUser } from "shared/utils/authToken";
import { pricingOBJ } from "Pricing/pricingClass";
import { OTPInput, Spinner } from "shared/components";
import Modal from "shared/quickComponents/modal";
import { OtpContainer } from "Pricing/Single/Styles";
import { AuxOtpText, OtpBtn, OtpBtnContainer } from "Auth/pages/ReceiveOtp/Styles";

type Props={
    pageAction: string;
    initialValues?: any;
    title?: string;
    setisOtpModalOpen?: any;
}
const Gateway=({pageAction, title, initialValues, setisOtpModalOpen }: Props)=>{
    const [isInward, setiIsInward] = useState(true);
    const [isOutward, setIsOutward] = useState(false);
    const [isMandate, setIsMandate] = useState(false);

    const [selectedPrice, setSelectedPrice] = useState<any>({});
    // console.log(initialValues)
    const [country, setCountry] = useState<any>({});
    const [countries, setCountries] = useState<any>([]);
    const [pricingName, setpricingName] = useState(selectedPrice?.name || "");
    const [percentageValue, setpercentageValue] = useState(selectedPrice?.defaultValue?.percentage || "0");
    const [fixedValue, setfixedValue] = useState(selectedPrice?.defaultValue?.flat || "0");
    const [benchmark, setBenchmark] = useState(selectedPrice?.defaultValue?.flatBenchmark || "0");
    const [cap, setCap] = useState(selectedPrice?.defaultValue?.cap || "0");
    const [currency, setCurrency] = useState(selectedPrice?.currency || "NGN");
    const [isPublic, setisPublic] = useState(true);
    const [tempId, settempID] = useState("");
    const [showActivityIndicator, setshowActivityIndicator] = useState(false);
    const [planType, setplanType] = useState("");
    const [Otp, setOtp] = useState("");
    const [authModalOpen, setAuthModalOpen] = useState(false);
    const [isOTPError, setisOTPError] = useState(false);
    const [action, setaction] = useState("");
    const [selectedPlanID, setSelectedPlanID] = useState("");


    const actions: any=[
        {label: "Create", action: "CREATE"},
        {label: "Edit", action: "UPDATE"},
        {label: "Assign Price", action: "ASSIGN"}
    ]
    const currencies: any=[
        { label: "NGN", value: "NGN" },
        { label: "USD", value: "USD" },
        { label: "EURO", value: "EURO" },
        { label: "POUNDS", value: "POUNDS" },
    ];

    let selectAction = actions.find((act: any)=>act.action==pageAction);

    const currentUser = getCurrentUser(); //Get current login user

    const getCountries=async()=>{
        const defat=Intl.DateTimeFormat().resolvedOptions();
    
        const Default=new Intl.Locale(defat.locale).region;
        //console.log("Browser country: ", Default)
        const response: any= await pricingOBJ.getAllCountry();
        //console.log("Countries: ", response)
        if (response) {
            let defaultCountry=response.find((ct: any)=>ct.isoAlpha2==Default);
            //console.log("Browser country: ", defaultCountry)
            setCountry(defaultCountry)
            setCountries(response)
        }
    }


    //===== This handles submit button on modal ==========
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setshowActivityIndicator(true);
        try{
            if (!percentageValue && !fixedValue) {
                toast.error("Percentage field and Fixed field can't be empty");
                setshowActivityIndicator(false);
            } else {
                let pricingType = "";
                let channel='';
                let status = "";
                if (percentageValue) pricingType = "PERCENTAGE";
                if (fixedValue) pricingType = "FLAT";
                if (percentageValue && fixedValue) pricingType = "DYNAMIC";

                if (isInward) channel = "INWARD";
                if (isOutward) channel = "OUTWARD";
                if (isMandate) channel = "MANDATE";

                delete country.flag
                const payload = {
                    app: "GATEWAY",
                    name: pricingName,
                    country: country.isoAlpha2,
                    currency,
                    benchmark,
                    cap,
                    channel,
                    default_value: {
                        percentage: percentageValue ? percentageValue : 0,
                        flat: fixedValue ? fixedValue : 0,
                        flatBenchmark: benchmark,
                        cap
                    },
                    type: pricingType ? pricingType : planType,
                };
                
                //switch is based on page action state
                switch (pageAction) {
                    case "EDIT":
                        let adminEmail = currentUser.email;
                        let pricingId = selectedPlanID;
                        let pricingPayload: any = {
                            name: pricingName,
                            status: isPublic ? "PUBLIC" : "PRIVATE",
                            value: {
                            percentage: percentageValue ? percentageValue : 0,
                            flat: fixedValue ? fixedValue : 0,
                            },
                        };
                        // // console.log("Edited payload ==>", payload, pageAction);
                        let feedback = await pricingOBJ.sendOTP({
                            adminEmail,
                            pricingId,
                            pricingPayload,
                        });
                        console.log("Feedback: ", feedback);
                        if (feedback?.status) {
                            //toast.success("OTP sent successfully!.");
                            // console.log("feedback data ====>", pricingPayload);
                            settempID(feedback.payload?.tempId);
                            setaction("UPDATE_PRICING_PLAN");
                            setisOtpModalOpen(true);
                            setAuthModalOpen(true)
                            // getplans();
                        }
                    break;
                    
                    case "ASSIGN":
                        
                        let mail = currentUser?.email;
                        let priceId = initialValues?.uuid;
                        
                        let pricePayload = {
                            pricingId: initialValues?.uuid,
                            serviceId: initialValues?.service,
                            channels: initialValues?.channels,
                            value: {
                                percentage: percentageValue ? percentageValue : 0,
                                flat: fixedValue ? fixedValue : 0,
                                flatBenchmark: benchmark ? benchmark : 0,
                                cap: cap ? cap : 0,
                            },
                        };
                        //alert(JSON.stringify(pricePayload))
                        let feedbacks = await pricingOBJ.sendOTP({
                            adminEmail: mail,
                            pricingId: priceId,
                            pricePayload,
                        });
                        
                        if (feedbacks?.status) {
                            console.log("Feedback: ", feedbacks);
                            settempID(feedbacks.payload?.tempId);
                            setaction("ASSIGN_PRICING_PLAN");
                            //setisOtpModalOpen(false);
                            setAuthModalOpen(true)
                            // getplans();
                        }
                    break;
                    default:
                    
                        const response = await pricingOBJ.addPricing(payload);
                        //console.log("Response: ", response);
                        if (response.status) {
                            toast.success(response?.message);
                            setpricingName("");
                            setpercentageValue("0");
                            setfixedValue("0");
                            setBenchmark("0");
                            setCap("0");
                        } else {
                            // fetchData();
                            //closeModal();
                            //getplans();
                            toast.error(response.message);
                        }
                    break;
                }
            }
        }catch(error: any){

        }finally{
            setshowActivityIndicator(false);
        }
    };
    //==========================================================

    const handleOTP = async (otp: string) => {
        if (otp.length === 6) {
            const otpResponse = await pricingOBJ.confirmOTP({
                otp,
                action,
                tempId,
            });
            if (otpResponse?.status) {
                setAuthModalOpen(false);
                setisOtpModalOpen(false);
                toast.success(otpResponse?.message)
            }else{
                toast.error(otpResponse?.message)
            }
        }
    };
    
    useEffect(()=>{
        getCountries();
        setSelectedPrice({...initialValues})
    }, []);
    
    return(
        <>
            <FormTitle>{title}</FormTitle>
            <PricingForm onSubmit={handleSubmit}>
                {(pageAction === "CREATE" || pageAction === "EDIT") && 
                    <>
                        <FormGroup>
                            <FormInputGroup>
                                <SelectField
                                value={country?.name}
                                setValue={(value: any) => setCountry(value)}
                                label="Select pricing country"
                                data={countries}
                                />
                            </FormInputGroup>
                            <FormInputGroup>
                                <SelectField
                                value={currencies?.label}
                                setValue={(value: any) => setCurrency(value)}
                                label="Currency"
                                data={currencies}
                                />
                            </FormInputGroup>
                        </FormGroup>
                        <FormInputGroup>
                            <InputLabel>Pricing Name</InputLabel>
                            <FormInput
                                type="text"
                                placeholder="Enter pricing name"
                                value={pricingName}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                setpricingName(event.target.value);
                                }}
                            />
                        </FormInputGroup>
                    </>
                }
                <FormGroup>
                    <FormInputGroup>
                        <InputLabel>Percentage (%)</InputLabel>
                        <FormInput
                        type="text"
                        placeholder=""
                        value={percentageValue}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            setpercentageValue(event.target.value);
                        }}
                        />
                    </FormInputGroup>

                    <PlusIcon>+</PlusIcon>
                    <FormInputGroup>
                        <InputLabel>Fixed</InputLabel>
                        <FormInput
                        type="text"
                        placeholder=""
                        value={fixedValue}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            setfixedValue(event.target.value);
                        }}
                        />
                    </FormInputGroup>
                </FormGroup>
                <FormGroup>
                    <FormInputGroup>
                        <InputLabel>Benchmark</InputLabel>
                        <FormInput
                        type="text"
                        placeholder=""
                        value={benchmark}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            setBenchmark(event.target.value);
                        }}
                        />
                    </FormInputGroup>
                    <FormInputGroup>
                        <InputLabel>Cap</InputLabel>
                        <FormInput
                        type="text"
                        placeholder=""
                        value={cap}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            setCap(event.target.value);
                        }}
                        />
                    </FormInputGroup>
                </FormGroup>

                {(pageAction === "CREATE" || pageAction === "EDIT") && 
                    <FormInputGroup>
                        <InputLabel>Price type:</InputLabel>
                        <TableActions>
                            <SharedCheckList
                                onChange={() => {
                                setiIsInward(true);
                                setIsMandate(false);
                                setIsOutward(false);
                                }}
                                checked={isInward}
                                label={"Inward"}
                                id={`1`}
                            />

                            <SharedCheckList
                                onChange={() => {
                                setiIsInward(false);
                                setIsMandate(true);
                                setIsOutward(false);
                                }}
                                checked={isMandate}
                                label={"Mandate"}
                                id={`1`}
                            />
                            <SharedCheckList
                                onChange={() => {
                                setiIsInward(false);
                                setIsMandate(false);
                                setIsOutward(true);
                                }}
                                checked={isOutward}
                                label={"Outward"}
                                id={`1`}
                            />
                        </TableActions>
                    </FormInputGroup>
                }
                <ModalBtn type="submit">
                    {showActivityIndicator ? <Spinner color="#fff" /> : selectAction.label}
                </ModalBtn>
            </PricingForm>

            <Modal
                isOpen={authModalOpen}
                closeButton={true}
                onClose={()=>{setAuthModalOpen(false)}}
                width="40%"
            >
                <div style={{ paddingBottom: "2rem" }}>
                <Title>Check your email for OTP</Title>
                <SubTitle>
                    We have sent a 6 - digit code to your email address. <br /> The code
                    expires shortly, please enter it soon.
                </SubTitle>
                <OtpContainer>
                    {" "}
                    <OTPInput
                    autoFocus
                    isNumberInput
                    length={6}
                    hasError={isOTPError}
                    errorStyle={{
                        borderColor: "red",
                    }}
                    inputStyle={{
                        border: "1px solid #828282",
                        width: "60px",
                        height: "60px",
                        fontSize: "30px",
                        color: "#000",
                        fontWeight: "400",
                        caretColor: "#000",
                        textAlign: "center",
                        borderRight: "0px",
                    }}
                    focusStyle={
                        {
                        //border: "1px solid #CFD3DB",
                        }
                    }
                    firstIndexStyle={{
                        borderTopLeftRadius: "8px",
                        borderBottomLeftRadius: "8px",
                        borderRight: "0px",
                    }}
                    lastIndexStyle={{
                        borderTopRightRadius: "8px",
                        borderBottomRightRadius: "8px",
                        borderRight: "1px solid #828282",
                        borderLeft: "1px solid #828282",
                    }}
                    className="otpContainer"
                    inputClassName="otpInput"
                    separator={
                        <span
                        style={{
                            marginLeft: "10px",
                            marginRight: "10px",
                            marginTop: "10%",
                            fontSize: "50px",
                            color: "black",
                            fontWeight: "bold",
                        }}
                        >
                        -
                        </span>
                    }
                    onChangeOTP={handleOTP}
                    />
                </OtpContainer>
                <OtpBtnContainer>
                    <OtpBtn onClick={() => {}}>
                        You didn't get an OTP ?<AuxOtpText> Resend</AuxOtpText>
                    </OtpBtn>
                </OtpBtnContainer>
                </div>
            </Modal>
        </>
        
    )
}


export default Gateway;